<template>
  <div class="list-wrapper">
    <div class=" w-100 sticky-top">
      <el-tabs v-model="searchData.active_name" @tab-click="onTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="文章" name="article"></el-tab-pane>
        <el-tab-pane label="视频" name="video"></el-tab-pane>
        <el-tab-pane
          :label="`草稿箱(${article ? article.draft_total : ''})`"
          name="draft"
        ></el-tab-pane>
        <el-tab-pane label="回收站" name="recycle" class=""></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-wrapper">
      <el-row>
        <el-col :span="6" class="status">
          <el-select
            v-model="searchData.status_str"
            placeholder="请选择"
            @change="claerPage"
            size="mini"
            v-if="searchData.status_str !== 'draft' && searchData.status_str !== 'recycle'"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div v-else style="height: 1px"></div>
          <el-button  size="mini" icon="el-icon-refresh-right" class=" ms-2" @click="search" ></el-button>
        </el-col>
        <el-col :span="18" class="t-right">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="mini"
            class="me-2"
            @change="search"
          ></el-date-picker>
          <el-input
            size="mini"
            placeholder="搜索"
            suffix-icon="el-icon-search"
            v-model="searchData.title"
            class="w-200 me-2"
            clearable
            @change="claerPage"
          ></el-input>
        </el-col>
      </el-row>
    </div>

    <div class="list" v-if="article">
      <div class="min" v-for="item in article.list" :key="item.index">
        <div class="poster">
          <el-carousel trigger="click">
            <el-carousel-item v-for="img in item.poster" :key="img.index">
              <el-image
                :src="img + '?x-oss-process=style/16x9'"
                fit="cover"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="m-l-20 content">
          <div class="tit">
            <router-link
              class="block"
              title="编辑"
              :class="!item.title ? 'font-gray' : ''"
              :to="{ path: './preview', query: { id: item.id } }"
              ><el-tag  type="danger" effect="plain" size="mini" v-if="item.type == 2"><i class="el-icon-video-camera me-1"></i>视频</el-tag><el-tag  type="danger"  size="mini"  v-if="item.type == 1"><i class="el-icon-document me-1"></i>文章</el-tag>
              {{ item.title || `标题未设置` }}</router-link
            >
            <div class="tag-group m-t">
              <span v-if="item.status === 3" class="tag tag-light">草稿</span>
              <span class="tag tag-info" v-if="item.is_published == 1 && item.is_set_publish !== 1">已发布</span>
              <span class="tag tag-info" v-if="item.status == 1 && item.is_set_publish === 1">已通过</span>
              <span v-if="item.status === 0" class="tag tag-warning"
                >审核中{{item.guid ? '(有更新)' : ''}}</span
              >
              <span v-if="item.status === 4" class="tag tag-warning1"
                >待发布(有更新)</span
              >
              <span class="tag tag-primary" v-if="item.status === 2"><i class="el-icon-warning-outline"></i> 未通过</span>
              <el-tag   size="small" class="ms-1" v-if="item.is_secret == 1"><i class="el-icon-lock me-1"></i>私密</el-tag>
              <el-tag effect="plain" type="success" class=" ms-1" v-if="item.is_original == 1" size="mini">原创</el-tag>
              <el-tag effect="plain" type="danger" class=" ms-1" v-if="item.is_original == 2" size="mini">转载</el-tag>
              <el-tag   size="small" type="warning" class="ms-1" v-if="item.is_set_publish == 1 && item.status !== 3"><i class="el-icon-time me-1"></i>定时{{item.publish_at}}发布</el-tag>
              <!-- <el-tooltip class="item" effect="dark" content="该内容被推荐为精选" placement="top-start">
                <span class="tag tag-info">荐</span>
              </el-tooltip> -->
              
            </div>
            <div v-if="item.status === 2" class="fs-10 mt-1 text-danger">{{item.fail_reason}}</div>
          </div>
          <div class="footer">
            <div class="time font-gray">{{ item.created_at }} 创建</div>
            <div class="btn">
              <el-button-group>
                <el-button
                  size="mini"
                  icon="el-icon-s-platform"
                  :disabled="!item.guid && (item.status !== 1 || item.is_set_publish == 1)"
                  @click.stop="goPcInfo(item)"
                  class="border-none"
                  >打开</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  @click.stop="onEdit(item)"
                  class="border-none"
                  :disabled="item.status == 0"
                  v-if="searchData.active_name !== 'recycle'"
                  >{{item.guid && item.status == 4 ? '编辑' : '编辑'}}</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-refresh-right"
                  @click.stop="onRefresh(item)"
                  class="border-none"
                  v-if="searchData.active_name === 'recycle'"
                  >恢复</el-button
                >
                <el-button
                  size="mini"
                  :icon="!item.guid ? 'el-icon-document-delete' : 'el-icon-refresh-left'"
                  @click.stop="onEditStatus(item)"
                  v-if="item.status == 0"
                  class="border-none"
                  >{{item.guid ? '撤回审核' :'取消发布'}}</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-refresh"
                  @click.stop="onEdit(item)"
                  v-if="item.guid && item.status == 4"
                  class="border-none"
                  >发布更新</el-button
                >
                <el-button
                  v-if="item.status >= 3 && item.status !== 4"
                  size="mini"
                  icon="el-icon-delete"
                  @click.stop="onDelect(item)"
                  class="border-none"
                  >删除</el-button>
                <el-dropdown v-if="item.status < 3 || item.status === 4" size="small" placement="bottom" :hide-on-click="false">
                  <span class="el-dropdown-link ms-2 px-1">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-mobile"><span @click="goPreview(item)">预览</span></el-dropdown-item>
                    <el-dropdown-item icon="el-icon-lock" v-if="item.is_secret == 0 && item.status !== 2" ><span @click.stop="editSecret(item, 1)">设为私密</span> </el-dropdown-item>
                    <el-dropdown-item icon="el-icon-unlock" v-if="item.is_secret == 1 && item.status !== 2" ><span @click.stop="editSecret(item, 0)">设为公开</span></el-dropdown-item>
                    <el-dropdown-item icon="el-icon-s-tools"><span @click="goSetting(item)">设置</span></el-dropdown-item>
                    <el-dropdown-item  icon="el-icon-delete"><span  @click.stop="onDelect(item)">删除</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
            </div>
          </div>
          <!-- <div class="status">
            <span class="err" v-if="item.status === 2">未通过</span>
            <span v-if="item.status === 0">审核中</span>
            <span v-if="item.status === 3">草稿</span>
          </div> -->
        </div>
      </div>
      <!-- 列表为空 -->
      <div v-if="article.is_none">
        <el-result icon="info" title="" subTitle="没有更多内容了...">
          <template slot="extra">
            <!-- <el-button type="primary" size="medium">刷新</el-button> -->
          </template>
        </el-result>
      </div>
    </div>
    <div class="page" v-if="article && article.total > 10">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="article.total"
        :page-size="10"
        :current-page="searchData.page"
        @current-change="pageChange"
      ></el-pagination>
    </div>


    <el-dialog
      title="提示"
      :visible.sync="refresh_show"
      width="30%"
      center>
      <span>您可选择将文章恢复至草稿箱或恢复至草稿箱并进入文章编辑页面！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refresh_show = false" size="small">取消</el-button>
        <el-button type="primary" @click="goRefresh(1)" size="small">恢复并编辑</el-button>
        <el-button type="primary" @click="goRefresh(2)" size="small">恢复</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { ArticleList } from "@/lib/article/list.js";
export default {
  data() {
    return {
      article: null,
      searchData: {
        page: this.$route.query.page * 1 || 1,
        size: 10,
        status: "all",
        title: this.$route.query.title || '',
        start_at: this.$route.query.start_at || '',
        end_at: this.$route.query.end_at || '',
        status_str: this.$route.query.status_str || 'all',
        type: this.$route.query.type || 'all',
        active_name: this.$route.query.active_name || 'all'
      },
      dateArr: this.$route.query.start_at ? [this.$route.query.start_at, this.$route.query.end_at] : '',
      refresh_show: false,
      refresh_data: null,
      statusOptions: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: 'publihsed',
          label: "已发布",
        },
        {
          value: 'audition',
          label: "审核中",
        },
        {
          value: 'auditback',
          label: "未通过",
        },
        {
          value: 'changed',
          label: "待发布(有更新)",
        }
      ],
    };
  },
  mounted () {
    let self = this
    setTimeout(() => {self.article = new ArticleList(this.searchData);}, 200)
    
  },
  methods: {
    onEdit(item) {
      this.$router.push({ name: "Publish", params: { id: item.id } });
    },
    goSetting (item) {
      this.$router.push(`./${item.id}/setting`);
    },
    onRefresh (item) {
      this.refresh_data = item
      this.refresh_show = true
    },
    goRefresh (type) {
      this.article.editStatus({id: this.refresh_data.id, status: 3}).then(res => {
        if (type === 1) {
          this.$router.push({ name: "Publish", params: { id: this.refresh_data.id } });
        } else {
          this.$message.success("已恢复至草稿箱，您可以在草稿箱内再次发布！");
        }
        this.refresh_show = false
        this.search()
      })
    },
    onDelect(item) {
      let msg = '是否删除该文章?已删除的文章可在回收站内二次编辑发布'
      if (this.searchData.status_str === 'recycle') {
        msg = '此操作将永久删除该文章, 是否继续?'
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.searchData.status_str === 'recycle') {
          this.article.del(item.id).then((res) => {
            this.article.getList(this.searchData);
          });
        } else {
          this.article.remove(item.id).then((res) => {
            this.article.getList(this.searchData);
          });
        }
        this.$message.success("删除成功！");
      });
    },
    goInfo(item) {
      window.open(`/article/info?id=${item.id}`);
    },
    pageChange(e) {
      this.searchData.page = e;
    },
    search() {
      if (!this.searchData.title) this.searchData.title = undefined;
      this.article.getList(this.searchData);
    },
    onTabClick(e) {
      if (e.name === 'all') {
        this.searchData.type = 'all'
        this.searchData.status_str = 'all'
      } else if (e.name === 'article') {
        this.searchData.type = 1
        this.searchData.status_str = 'all'
      } else if (e.name === 'video') {
        this.searchData.type = 2
        this.searchData.status_str = 'all'
      } else if (e.name === 'draft') {
        this.searchData.type = 'all'
        this.searchData.status_str = 'draft'
      } else if (e.name === 'recycle') {
        this.searchData.type = 'all'
        this.searchData.status_str = 'recycle'
      }
      this.claerPage()
      // this.search();
    },
    claerPage () {
      this.searchData.page = 1
    },
    // 修改文章状态
    onEditStatus (item) {
      let self = this
      let status = 3
      if (item.guid) status = 4
      this.$confirm('确认取消发布该文章?取消发布的文章您可以在草稿箱内查看', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        self.article.editStatus({id: item.id, status}).then(res => {
          self.$message.success("已成功取消发布！");
          self.search()
        })
      })
    },
    editSecret (item, is_secret) {
      let self = this
      let msg = is_secret == 1 ? '确认将该文章设为私密状态？私密状态下文章仅可在后台预览中查看！' : '确认将该文章设为公开状态？公开状态下文章所有人可见！'
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        self.article.editSecret({id: item.id, is_secret}).then(res => {
          self.$message.success("修改成功！");
          self.search()
        })
      })
    },
    goPreview(item) {
      window.open(`/article/preview?id=${item.id}`);
    },
    goPcInfo (item) {
      window.open(item.guid);
    }
  },
  watch: {
    searchData: {
      deep: true,
      handler (newVal, oldVal) {
        for (var key in newVal) {
          if (newVal[key] === '' || newVal[key] === false || (newVal[key] === 'all' && key === 'status')) {
            newVal[key] = undefined
          }
        }
        this.$router.push({ path: '/article/', query: newVal }, () => {this.search()})
      }
    },
    dateArr: {
      deep: true,
      handler (newVal, oldVal) {
        if (newVal) {
          this.searchData.start_at = newVal[0]
          this.searchData.end_at = newVal[1]
        } else {
          this.searchData.start_at = undefined
          this.searchData.end_at = undefined
        }
      }
    }
  }
};
</script>